import React from "react"
import Beach from "./images/beach.jpg"

export function LandingPage() {
   return (
      <>
         <img src={Beach} className="homeImage rounded-1" alt="Landing Page"/>
      </>
   )
}